import React from 'react';
import { Link } from 'react-router-dom';

interface PillarCardProps {
  to: string;
  icon: string;
  title: string;
  description: string;
  primary?: boolean;
}

const PillarCard: React.FC<PillarCardProps> = ({ to, icon, title, description, primary }) => (
  <Link
    to={to}
    className={`block bg-white rounded-2xl p-8 text-center shadow-sm hover:shadow-lg transition-all border-2 ${
      primary 
        ? 'border-green-600 bg-green-50' 
        : 'border-transparent hover:border-slate-200'
    }`}
  >
    {primary && (
      <div className="text-xs font-semibold uppercase tracking-wider text-green-600 mb-2">
        Most Important
      </div>
    )}
    <div className="text-5xl mb-4">{icon}</div>
    <h3 className="text-2xl font-bold mb-3 text-slate-900">{title}</h3>
    <p className="text-slate-500 text-sm leading-relaxed">{description}</p>
    <div className="mt-4 text-sm font-medium text-green-700">
      Learn more →
    </div>
  </Link>
);

const PillarsOverview: React.FC = () => (
  <section className="py-20 px-6">
    <div className="max-w-7xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-slate-900">
        Four Reasons to Use Megadish
      </h2>
      <p className="text-lg text-slate-500 text-center mb-12 max-w-2xl mx-auto">
        One simple device. Multiple ways it makes your life easier. Click any pillar to learn more.
      </p>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <PillarCard
          to="/protect"
          icon="🔒"
          title="Protect"
          description="Your devices connect to Megadish's private network, not the public WiFi. Hackers can't see you."
          primary
        />
        <PillarCard
          to="/share"
          icon="👨‍👩‍👧‍👦"
          title="Share"
          description='The family connects to "Megadish" — it&apos;s already saved. You handle what&apos;s underneath.'
        />
        <PillarCard
          to="/extend"
          icon="📡"
          title="Extend"
          description="Dish technology reaches WiFi your phone can't. Beach from hotel, boat from shore."
        />
        <PillarCard
          to="/multiply"
          icon="➕"
          title="Multiply"
          description="WiFi allows one device? Megadish counts as one but gives you four. Essential for 2FA."
        />
      </div>
    </div>
  </section>
);

export default PillarsOverview;
